import { render, staticRenderFns } from "./materialRequisitionDetail.vue?vue&type=template&id=f8743470&scoped=true&"
import script from "./materialRequisitionDetail.vue?vue&type=script&lang=js&"
export * from "./materialRequisitionDetail.vue?vue&type=script&lang=js&"
import style0 from "./materialRequisitionDetail.vue?vue&type=style&index=0&id=f8743470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8743470",
  null
  
)

export default component.exports